/**
 * Enum loại chi đầu tư
 */
export default {
  /**
   * nguồn kinh phí
   */
  Source: 1,
  /**
   * Nhiệm vụ chi đầu tư
   */
  Invest: 2,

  /**
   * Dự án
   */
  Project: 3
};
